const headRowsManagementEquip = {
  equipmentModelName: 'Equipment',
  equipmentGroupName: 'Group',
  placeName: 'Local',
  referenceName: 'Reference point',
  description: 'Description',
  company: 'Third party companies',
  createdAt: 'Created At',
};

export default headRowsManagementEquip;
